import InstitutionWorkspace from './InstitutionWorkspace';

export default function AgentInstitutionsPage() { return <InstitutionWorkspace />; }
/* legacy screen retained below for design reference
  const [institutions, setInstitutions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [form, setForm] = useState({ name: '', country: '', description: '' });
  const [logoFile, setLogoFile] = useState(null);
  const [saving, setSaving] = useState(false);

  const token = localStorage.getItem('token');

  const fetchInstitutions = () => {
    setLoading(true);
    fetch(`${API_BASE}/admin/institutions`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => r.json())
      .then((json) => setInstitutions(json.success ? json.data : []))
      .finally(() => setLoading(false));
  };

  useEffect(fetchInstitutions, []);

  const filtered = institutions.filter((i) =>
    i.name.toLowerCase().includes(search.toLowerCase()) || i.country.toLowerCase().includes(search.toLowerCase())
  );

  const handleCreate = async (e) => {
    e.preventDefault();
    setSaving(true);
    const fd = new FormData();
    Object.entries(form).forEach(([k, v]) => fd.append(k, v));
    if (logoFile) fd.append('logo', logoFile);
    await fetch(`${API_BASE}/admin/institutions`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
      body: fd,
    });
    setSaving(false);
    setModalOpen(false);
    setForm({ name: '', country: '', description: '' });
    setLogoFile(null);
    fetchInstitutions();
  };

  return (
    <div className="bg-[#f7f9fb] font-['Plus_Jakarta_Sans'] min-h-screen">
      <AgentSidebar />
      <main className="pt-16 md:pt-2 md:ml-64 min-h-screen p-8">
        <header className="flex justify-between items-end mb-10">
          <div>
            <h2 className="text-3xl font-bold text-[#00255a]">Partner Institutions</h2>
            <p className="text-[#64748b] mt-2">Add new university/employer partnerships.</p>
          </div>
          <button
            onClick={() => setModalOpen(true)}
            className="text-white px-6 py-3 rounded-lg font-semibold shadow-lg flex items-center gap-2 hover:scale-105 transition-all"
            style={{ background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 60%, #ff7b7b 100%)' }}
          >
            <span className="material-symbols-outlined">add</span>
            Add Institution
          </button>
        </header>

        <div className="bg-white rounded-xl border border-[#e2e8f0] shadow-sm overflow-hidden">
          <div className="p-6 border-b border-[#e2e8f0]">
            <div className="relative w-72">
              <span className="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-[#64748b] text-lg">search</span>
              <input
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Search institutions..."
                className="w-full pl-10 pr-4 py-2 bg-white border border-[#e2e8f0] rounded-lg text-sm focus:ring-2 focus:ring-[#00255a]/10 outline-none"
              />
            </div>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full text-left">
              <thead>
                <tr className="bg-[#f2f4f6]/50">
                  {['Logo', 'Institution Name', 'Country', 'Linked Openings', 'Status'].map((h) => (
                    <th key={h} className="px-6 py-4 text-[#00255a]/70 uppercase text-xs">{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody className="divide-y divide-[#e2e8f0]">
                {loading ? (
                  <tr><td colSpan="5" className="p-12 text-center text-[#64748b]">Loading...</td></tr>
                ) : filtered.length === 0 ? (
                  <tr><td colSpan="5" className="p-12 text-center text-[#64748b]">No institutions found.</td></tr>
                ) : (
                  filtered.map((inst) => (
                    <tr key={inst.id} className="hover:bg-[#f7f9fb] transition-colors">
                      <td className="px-6 py-4">
                        <div className="w-10 h-10 rounded-lg bg-[#e0e3e5] flex items-center justify-center overflow-hidden border border-[#e2e8f0]">
                          {inst.logoUrl ? (
                            <img className="w-full h-full object-cover" src={inst.logoUrl} alt={inst.name} />
                          ) : (
                            <span className="material-symbols-outlined text-[#00255a]">account_balance</span>
                          )}
                        </div>
                      </td>
                      <td className="px-6 py-4"><p className="font-bold text-[#00255a]">{inst.name}</p></td>
                      <td className="px-6 py-4 text-sm">{inst.country}</td>
                      <td className="px-6 py-4">
                        <span className="px-3 py-1 bg-[#1e3c72]/10 text-[#1e3c72] rounded-full text-xs font-bold">{inst.linkedOpenings} Openings</span>
                      </td>
                      <td className="px-6 py-4">
                        <span className={`px-3 py-1 rounded-full text-xs font-bold inline-flex items-center gap-1 ${
                          inst.isActive ? 'bg-green-100 text-green-700' : 'bg-[#e0e3e5] text-[#44474f]'
                        }`}>
                          <span className={`w-1.5 h-1.5 rounded-full ${inst.isActive ? 'bg-green-500' : 'bg-[#747781]'}`} />
                          {inst.isActive ? 'Active' : 'Hidden'}
                        </span>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        {modalOpen && (
          <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4" onClick={() => setModalOpen(false)}>
            <form onSubmit={handleCreate} className="bg-white rounded-2xl p-8 w-full max-w-md shadow-2xl space-y-4" onClick={(e) => e.stopPropagation()}>
              <h3 className="text-xl font-bold text-[#00255a] mb-2">Add Institution</h3>
              <input
                required
                placeholder="Institution Name"
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                className="w-full px-4 py-3 rounded-lg border border-[#e2e8f0] focus:ring-2 focus:ring-[#00255a]/10 outline-none"
              />
              <input
                required
                placeholder="Country"
                value={form.country}
                onChange={(e) => setForm({ ...form, country: e.target.value })}
                className="w-full px-4 py-3 rounded-lg border border-[#e2e8f0] focus:ring-2 focus:ring-[#00255a]/10 outline-none"
              />
              <textarea
                placeholder="Description (optional)"
                rows="3"
                value={form.description}
                onChange={(e) => setForm({ ...form, description: e.target.value })}
                className="w-full px-4 py-3 rounded-lg border border-[#e2e8f0] focus:ring-2 focus:ring-[#00255a]/10 outline-none resize-none"
              />
              <label className="block">
                <span className="text-xs font-bold text-[#44474f] uppercase mb-1 block">Logo</span>
                <input type="file" accept="image/*" onChange={(e) => setLogoFile(e.target.files[0])} className="text-sm" />
              </label>
              <div className="flex gap-3 pt-2">
                <button type="button" onClick={() => setModalOpen(false)} className="flex-1 py-3 border border-[#e2e8f0] rounded-lg font-semibold text-[#44474f]">
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={saving}
                  className="flex-1 py-3 text-white rounded-lg font-semibold disabled:opacity-60"
                  style={{ background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 60%, #ff7b7b 100%)' }}
                >
                  {saving ? 'Saving...' : 'Add Institution'}
                </button>
              </div>
            </form>
          </div>
        )}
      </main>
    </div>
  );
}
*/
